var _style, _g, _g2, _polygon, _g3, _g4, _polygon2, _path, _path2, _g5, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OBJECTS",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 279.87 208.06",
    style: {
      enableBackground: "new 0 0 279.87 208.06"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#4D4D4D;}\r\n\t.st1{fill:#202124;}\r\n\t.st2{fill:url(#SVGID_1_);}\r\n\t.st3{opacity:0.3;fill:url(#SVGID_00000032637950090792924210000009073532000971930240_);}\r\n\t.st4{opacity:0.3;fill:url(#SVGID_00000159437201042393624360000016817312798386169746_);}\r\n\t.st5{opacity:0.53;fill:url(#SVGID_00000173848481191432797650000008775767776572832445_);}\r\n\t.st6{fill:url(#SVGID_00000169549667775778706410000011914473379296849538_);}\r\n\t.st7{opacity:0.3;fill:url(#SVGID_00000008133681406363487620000002030080485103590304_);}\r\n\t.st8{opacity:0.3;fill:url(#SVGID_00000178921360387879073280000017518997301399624861_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 140.53,
    cy: 81.44,
    rx: 79,
    ry: 30.7
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 140.53,
    cy: 31.74,
    rx: 38.94,
    ry: 14
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "179.38,31.24 140.5,31.24 101.61,31.24 95.47,83.24 140.5,92.24 185.52,83.24  "
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 140.53,
    cy: 81.44,
    rx: 79,
    ry: 30.7
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 140.53,
    cy: 31.74,
    rx: 38.94,
    ry: 14
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "179.38,31.24 140.5,31.24 101.61,31.24 95.47,83.24 140.5,92.24 185.52,83.24  "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M140.19,115.24c0,0-30-1-46-6c0,0,5,16,11,21s24,4,25,4s5-11,10-11s9,11,10,11s19,1,25-4s11-21,11-21 C170.19,114.24,140.19,115.24,140.19,115.24z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 94.1923,
    y1: 121.783,
    x2: 186.1923,
    y2: 121.783
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0B6F5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C39A"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M140.19,115.24c0,0-30-1-46-6c0,0,5,16,11,21s24,4,25,4s5-11,10-11s9,11,10,11s19,1,25-4s11-21,11-21 C170.19,114.24,140.19,115.24,140.19,115.24z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.19,190.93c0,0-42.14-39.05-56.49-90.12c0,0-8.97,10.01-12.55,22.03 C49.56,134.86,85.43,174.91,122.19,190.93z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "79.86,162.48 22.66,176.13 13.69,201.24 38.8,201.24 42.39,181.51 89.91,167.17  "
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M158.69,190.93c0,0,42.14-39.05,56.49-90.12c0,0,8.97,10.01,12.55,22.03 C231.32,134.86,195.46,174.91,158.69,190.93z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "201.03,162.48 258.23,176.13 267.19,201.24 242.08,201.24 238.5,181.51 190.97,167.17  "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066504987498097202730000017899362970224527268_",
    gradientUnits: "userSpaceOnUse",
    x1: 124.8674,
    y1: -2.6445,
    x2: 123.8673,
    y2: 100.3556
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4005,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000066504987498097202730000017899362970224527268_)"
    },
    d: "M133.53,36.08 c0,0-0.31,0-0.83-0.01c-2.27-0.05-8.62-0.3-12-1.66l-5.81,61.15c0,0,5.12,2.81,14.55,3.21L133.53,36.08z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000161589517221254562300000006539130891904170375_",
    gradientUnits: "userSpaceOnUse",
    x1: 105.9905,
    y1: 99.9718,
    x2: 105.6708,
    y2: 132.8923
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4005,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000161589517221254562300000006539130891904170375_)"
    },
    d: "M114.36,132.45 c0,0-5.44-0.73-9-4.04s-8.17-16.67-8.17-16.67s9,2.33,14.5,2.92C111.69,114.66,110.03,122.87,114.36,132.45z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083797251656918413210000001344393281079405232_",
    gradientUnits: "userSpaceOnUse",
    x1: 180.7843,
    y1: -0.0714,
    x2: 179.8736,
    y2: 93.723
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4005,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.53,
      fill: "url(#SVGID_00000083797251656918413210000001344393281079405232_)"
    },
    d: "M177.75,33.68l6.48,57.12 c0,0-1.25,1.33-2.49,1.45l-5.61-58.56H177.75z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000048487519508022426260000015704252022822708133_",
    gradientUnits: "userSpaceOnUse",
    x1: 179.4767,
    y1: 99.5318,
    x2: 179.1732,
    y2: 130.7953
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4005,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000048487519508022426260000015704252022822708133_)"
    },
    d: "M173.65,130.24 c0,0,5.33-3.21,11.24-19.4l-4.05,1.3C180.85,112.15,179.69,123.05,173.65,130.24z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181057925742711097770000014319731510471681205_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.0089,
    y1: 91.4695,
    x2: 74.2202,
    y2: 172.6949
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4005,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000181057925742711097770000014319731510471681205_)"
    },
    d: "M94.19,171.59 c0,0-21.9-17.26-37.6-51.05c0,0-1.28,1.67-1.87,5.64C54.14,130.14,69.44,155.44,94.19,171.59z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000037672662435063193950000011440278398306008209_",
    gradientUnits: "userSpaceOnUse",
    x1: 55.2508,
    y1: 169.3007,
    x2: 12.2508,
    y2: 212.3007
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4005,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000037672662435063193950000011440278398306008209_)"
    },
    points: "79.92,164.06  23.7,177.37 15.72,199.92 22.55,199.92 28.33,179.68 82.12,165.91  "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.6c8bce65a5fbc92ea0243ff17a1d3bf4.svg";
export { ForwardRef as ReactComponent };